import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Input from "@material-ui/core/Input";

import customInputStyle from "./inputStyle";

function CustomInput({ ...props }) {
    const {
        classes,
        formControlProps,
        labelText,
        id,
        labelProps,
        inputProps,
        error,
        white,
        inputRootCustomClasses,
        success,
        required,
        helperText
    } = props;

    const labelClasses = classNames({
        [classes.labelRoot]: true,
        [classes.labelRootError]: error,
        [classes.labelRootSuccess]: success && !error,
        [classes.whiteLabelRoot]: white && !error && !success,
    });
    const underlineClasses = classNames({
        [classes.underlineError]: error,
        [classes.underlineSuccess]: success && !error,
        [classes.underline]: true,
        [classes.whiteUnderline]: white && !error && !success
    });
    const marginTop = classNames({
        [inputRootCustomClasses]: inputRootCustomClasses !== undefined
    });
    const inputClasses = classNames({
        [classes.input]: true,
        [classes.errorInput]: error,
        [classes.successInput]: success && !error,
        [classes.whiteInput]: white && !error && !success
    });
    const helperTextClasses = classNames({
        [classes.formHelperText]: true,
        [classes.formHelperTextError]: error,
        [classes.formHelperTextSuccess]: success && !error,
        [classes.formHelperTextWhite]: white && !error && !success,
    });
    var formControlClasses;
    if (formControlProps !== undefined) {
        formControlClasses = classNames({
            [formControlProps.className]: true,
            [classes.formControl]: true, 
            [classes.errorFormControl]: error, 
            [classes.successFormControl]: success && !error, 
            [classes.whiteFormControl]: white && !success && !error, 
        })
    } else {
        formControlClasses = classNames({
            [classes.formControl]: true, 
            [classes.errorFormControl]: error, 
            [classes.successFormControl]: success && !error, 
            [classes.whiteFormControl]: white && !success && !error, 
        });
    }
    return (
        <FormControl {...formControlProps} className={formControlClasses}
        required={required} error={error} >
            {labelText !== undefined ? (
                <InputLabel
                    className={labelClasses}
                    htmlFor={id}
                    {...labelProps}
                >
                    {labelText}
                </InputLabel>
            ) : null}
            <Input
                classes={{
                    input: inputClasses,
                    root: marginTop,
                    disabled: classes.disabled,
                    underline: underlineClasses,
                }}
                id={id}
                {...inputProps}
                required={required}
            />
            <div className={helperTextClasses}>{helperText}</div>
        </FormControl>
    );
}

CustomInput.propTypes = {
    classes: PropTypes.object.isRequired,
    labelText: PropTypes.node,
    labelProps: PropTypes.object,
    id: PropTypes.string,
    inputProps: PropTypes.object,
    formControlProps: PropTypes.object,
    inputRootCustomClasses: PropTypes.string,
    error: PropTypes.bool,
    success: PropTypes.bool,
    white: PropTypes.bool,
    helperText: PropTypes.object,
};

export default withStyles(customInputStyle)(CustomInput);
